import React  from 'react';
import { CardMedia } from '@mui/material'
// import { useSetRecoilState } from 'recoil';
// import { imageProfessionalState, showMoldalImageProfessionalState } from './state/atoms';
import useImageProfessional from 'src/Professional/hooks/useImageProfessional';

const ProfessionalPhoto = ({
    width = 82,
    height = 120,
    widthIconHeader = 32,
    heightIconHeader = 32,
    image,
    alt,
    especialidades,
    rut
}) => {
    // const setShowMoldalImageProfessionalState = useSetRecoilState(showMoldalImageProfessionalState);
    // const setImageProfessional = useSetRecoilState(imageProfessionalState);
    // const handleShowImage = (el) => ev =>  {
    //     setImageProfessional(el)
    //     setShowMoldalImageProfessionalState(true);
    // }

    const { loadImageProfessional } = useImageProfessional();
    // if(rut.trim() == '108' || rut.trim() == '94' || rut.trim() == '86' || rut.trim() == '78' || rut.trim() == '51' || rut.trim() == '43'  || rut.trim() == '19'  ){
    //     image = loadImageProfessional(rut);
    // }

    return (
        <div>
            <CardMedia
                style={{ borderRadius: 5, position: 'sticky' }}
                component="img"
                image={`${process.env.REACT_APP_ROOT_SERVER_PATH}/static/images/icon_medico.png`}
                alt="icono_medico"
                sx={{
                    height: heightIconHeader,
                    width: widthIconHeader
                }}
            />

            <CardMedia
                style={{ borderRadius: 5 }}
                component="img"
                //image={especialidades != 'Imagenologia' ? image : loadImageProfessional(rut)}
                image={image}
                alt={alt}
                sx={{
                    marginTop: `-${heightIconHeader}px`,
                    height: height,
                    width: width
                }}
            />
        </div>
    )
}

export default ProfessionalPhoto
